import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col lg:flex-row items-start lg:items-center justify-end gap-4" }
const _hoisted_2 = { class: "flex flex-col lg:flex-row items-start lg:items-center gap-2 w-full lg:w-max" }
const _hoisted_3 = { class: "text-base font-semibold text-black-lp-300 flex-1 text-left lg:text-right" }
const _hoisted_4 = { class: "flex flex-col lg:flex-row items-start lg:items-center gap-2" }
const _hoisted_5 = { class: "text-base font-semibold text-black-lp-300 flex-1 text-left lg:text-right" }
const _hoisted_6 = { class: "w-full lg:w-32" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateRangeCompare = _resolveComponent("DateRangeCompare")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("dashboard.filterGrouping.comparisonTitle")), 1),
      _createVNode(_component_DateRangeCompare, {
        modelValue: _ctx.localDates,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.localDates = $event)),
        onApply: _ctx.onFilter,
        class: "w-full lg:w-116"
      }, null, 8, ["modelValue", "onApply"])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("dashboard.filterGrouping.showData")), 1),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_CustomDropdown, {
          modelValue: _ctx.localGroupBy,
          "onUpdate:modelValue": [
            _cache[2] || (_cache[2] = ($event: any) => (_ctx.localGroupBy = $event)),
            _ctx.onFilter
          ],
          preventUnselect: "",
          "selected-item": _ctx.localGroupBy,
          options: _ctx.listGroupBy
        }, null, 8, ["modelValue", "onUpdate:modelValue", "selected-item", "options"])
      ])
    ])
  ]))
}